/* Zenvo storefront components — sliders, countdowns, quick add, delivery estimate */
(function () {
  'use strict';

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------------- Horizontal product scrollers ---------------- */
  function initScroller(root) {
    if (root.__zv) return; root.__zv = true;
    var track = root.querySelector('.zv-track');
    if (!track) return;
    var prev = root.querySelector('[data-zv-prev]');
    var next = root.querySelector('[data-zv-next]');
    var bar = root.querySelector('.zv-progress span');
    var step = function () {
      var item = track.firstElementChild;
      return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth;
    };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) {
        var ratio = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(ratio * 100, 12) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / Math.max(ratio, .12)) - 1) * 100 : 0) + '%)';
        bar.parentElement.hidden = max <= 2;
      }
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------------- Hero slider ---------------- */
  function initHero(root) {
    if (root.__zv) return; root.__zv = true;
    var track = root.querySelector('.zv-hero__track');
    var slides = track ? track.children : [];
    if (!track || slides.length < 2) return;
    var dots = root.querySelectorAll('.zv-hero__dot');
    var idx = 0, timer = null;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;
    var go = function (i) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
    };
    var setActive = function () {
      idx = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-current', i === idx); });
    };
    var play = function () { if (delay) { clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, delay); } };
    var stop = function () { clearInterval(timer); };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); play(); }); });
    var p = root.querySelector('.zv-hero__nav--prev'), n = root.querySelector('.zv-hero__nav--next');
    if (p) p.addEventListener('click', function () { go(idx - 1); play(); });
    if (n) n.addEventListener('click', function () { go(idx + 1); play(); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(setActive, 60); }, { passive: true });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    root.addEventListener('touchstart', stop, { passive: true });
    setActive(); play();
  }

  /* ---------------- Countdowns ----------------
     data-end="ISO date"        fixed end date
     data-mode="daily"          resets every midnight (visitor local time)
     data-mode="hours" data-hours="n"  rolling n-hour window per visitor (stored)
     data-expired="hide|zero"   behaviour when a fixed date passes            */
  function endFor(el) {
    var mode = el.dataset.mode || 'date';
    var now = new Date();
    if (mode === 'daily') {
      var e = new Date(now); e.setHours(23, 59, 59, 999); return e.getTime();
    }
    if (mode === 'hours') {
      var hrs = parseFloat(el.dataset.hours || '6');
      var key = 'zv-cd-' + (el.dataset.key || 'g');
      var stored = 0;
      try { stored = parseInt(localStorage.getItem(key) || '0', 10); } catch (err) {}
      // restart when expired, missing, or longer than the configured length (e.g. after changing 12h -> 6h)
      if (!stored || stored <= now.getTime() || stored - now.getTime() > hrs * 3600000 + 1000) {
        stored = now.getTime() + hrs * 3600000;
        try { localStorage.setItem(key, String(stored)); } catch (err) {}
      }
      return stored;
    }
    var d = Date.parse(el.dataset.end || '');
    return isNaN(d) ? 0 : d;
  }
  function initCountdown(el) {
    if (el.__zv) return; el.__zv = true;
    var end = endFor(el);
    var start = Date.now();
    var parts = {
      d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'),
      m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]')
    };
    var bar = (el.closest('.zv-timer') || el).querySelector('[data-zv-bar]');
    var hideTarget = el.closest('[data-zv-cd-wrap]') || el;
    var tick = function () {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (el.dataset.mode === 'daily' || el.dataset.mode === 'hours') { clearInterval(iv); el.__zv = false; initCountdown(el); return; }
        if (el.dataset.expired !== 'zero') { hideTarget.hidden = true; }
        diff = 0; clearInterval(iv);
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (parts.d) { parts.d.textContent = pad(d); } else { h += d * 24; }
      if (parts.d && d === 0 && el.dataset.hideZeroDays === 'true') {
        var box = parts.d.closest('[data-zv-unit]'); if (box) { box.hidden = true; var sep = box.nextElementSibling; if (sep && sep.hasAttribute('data-zv-sep')) sep.hidden = true; }
      }
      if (parts.h) parts.h.textContent = pad(h);
      if (parts.m) parts.m.textContent = pad(m);
      if (parts.s) parts.s.textContent = pad(sec);
      if (bar) {
        var total = el.dataset.mode === 'daily' ? 86400000 : (el.dataset.mode === 'hours' ? parseFloat(el.dataset.hours || '6') * 3600000 : Math.max(end - start, 1));
        bar.style.width = Math.max(6, Math.min(100, (diff / total) * 100)) + '%';
      }
    };
    var iv = setInterval(tick, 1000); tick();
  }

  /* ---------------- Quick add to cart (product cards) ---------------- */
  function addToCart(form) {
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (window.theme && theme.settings && theme.settings.cartType === 'page') return true; // let it submit normally
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var fd = new FormData(form);
    if (sections.length) { fd.append('sections', sections); fd.append('sections_url', window.location.pathname); }
    if (btn) btn.classList.add('is-loading');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { throw new Error(state.description || state.message); }
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = state.sections;
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: fd.get('id'), cart: cart });
          }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') {
            if (!state.sections) document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            else drawer.show(btn);
          } else {
            window.location.href = root + 'cart';
          }
          if (btn) { btn.classList.add('is-added'); btn.innerHTML = btn.dataset.added || '✓ Added'; setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 2200); }
        });
      })
      .catch(function (e) { alert(e.message || 'Could not add to cart'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    return false;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-zv-atc]');
    if (!form) return;
    if (addToCart(form) === false) e.preventDefault();
  });

  /* ---------------- Estimated delivery ---------------- */
  function addBusinessDays(date, days, skip) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (skip.indexOf(d.getDay()) === -1) added++;
    }
    return d;
  }
  function initDelivery(el) {
    if (el.__zv) return; el.__zv = true;
    var min = parseInt(el.dataset.min || '2', 10), max = parseInt(el.dataset.max || '5', 10);
    var skip = (el.dataset.skip || '0').split(',').filter(Boolean).map(Number);
    var cutoff = parseInt(el.dataset.cutoff || '0', 10);
    var locale = el.dataset.locale || 'en-PK';
    var now = new Date();
    var base = new Date(now);
    var afterCutoff = cutoff > 0 && now.getHours() >= cutoff;
    if (afterCutoff || skip.indexOf(now.getDay()) !== -1) base = addBusinessDays(now, 1, skip);
    var fmt = function (d) { return d.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' }); };
    var dispatch = (afterCutoff || skip.indexOf(now.getDay()) !== -1) ? base : now;
    var from = addBusinessDays(base, min, skip), to = addBusinessDays(base, max, skip);
    var set = function (sel, v) { el.querySelectorAll(sel).forEach(function (n) { n.textContent = v; }); };
    set('[data-zv-from]', fmt(from));
    set('[data-zv-to]', fmt(to));
    set('[data-zv-range]', min === max ? fmt(from) : fmt(from) + ' – ' + fmt(to));
    set('[data-zv-today]', fmt(now));
    set('[data-zv-dispatch]', dispatch === now ? (el.dataset.todayLabel || 'Today') : fmt(dispatch));
    var cut = el.querySelector('[data-zv-cutoff]');
    if (cut) {
      if (!cutoff || afterCutoff || skip.indexOf(now.getDay()) !== -1) { cut.closest('[data-zv-cutoff-wrap]').hidden = true; }
      else {
        var tick = function () {
          var e = new Date(); var end = new Date(e); end.setHours(cutoff, 0, 0, 0);
          var s = Math.max(0, Math.floor((end - e) / 1000));
          if (!s) { cut.closest('[data-zv-cutoff-wrap]').hidden = true; return; }
          cut.textContent = Math.floor(s / 3600) + 'h ' + pad(Math.floor((s % 3600) / 60)) + 'm ' + pad(s % 60) + 's';
        };
        tick(); setInterval(tick, 1000);
      }
    }
  }

  /* ---------------- Boot ---------------- */
  function initAccordions() {
    if (window.innerWidth >= 750) return;
    document.querySelectorAll('.zv-acc[open]:not([data-zv-acc])').forEach(function (d) { d.setAttribute('data-zv-acc', ''); d.removeAttribute('open'); });
  }
  function init(scope) {
    scope = scope || document;
    initAccordions();
    scope.querySelectorAll('[data-zv-scroller]').forEach(initScroller);
    scope.querySelectorAll('[data-zv-hero]').forEach(initHero);
    scope.querySelectorAll('[data-zv-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-zv-delivery]').forEach(initDelivery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // product page sections get re-rendered on variant change in some themes
  var moTimer;
  new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(function () { init(); }, 200);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* Sticky bar "Checkout": add the selected variant to cart, then go straight to checkout */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-zv-checkout]');
    if (!btn || btn.disabled) return;
    var form = document.getElementById(btn.getAttribute('form'));
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var bar = btn.closest('product-sticky-form');
    var err = bar && bar.querySelector('.product-form__error-message');
    if (err) { err.hidden = true; err.textContent = ''; }
    btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) throw new Error(res.d.description || res.d.message || 'Could not add to cart');
        window.location.href = root + 'checkout';
      })
      .catch(function (ex) {
        btn.removeAttribute('aria-busy');
        if (err) { err.hidden = false; err.textContent = ex.message; } else { window.alert(ex.message); }
      });
  }, true);
})();
